














































































































































import { Component, Mixins, Ref } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import PolicyInfoContent from "../components/policy-info-content.vue"
import CompareHtml from "../components/compare-html.vue"
import policyService from "@/services/policy.service"
import DeployTimeModal from "../components/deploy-time.vue"
import PageMixin from "@/mixins/page"
import { LogColumns, getHistoryColumns } from "./constant"
import { saveAs } from "file-saver"
import { str2Html } from "@/utils"
import { asBlob } from "html-docx-js/dist/html-docx"
import { mapGetters } from "vuex"
import config from "@/config"
@Component({
    components: {
        PageHeader,
        PolicyInfoContent,
        CompareHtml,
        DeployTimeModal
    },
    computed: {
        ...mapGetters(["currentUser"]),
        ...mapGetters("common", ["PolicyStatusMap", "PolicyStatusMap", "privacy_policy_status"])
    }
})
export default class PolicyDetail extends Mixins(PageMixin) {
    readonly privacy_policy_status: any
    readonly logColumns = LogColumns
    readonly PolicyStatusMap: any
    readonly currentUser: any
    loading = false
    editor: any = null
    toolbarConfig = {}
    editorConfig = { placeholder: "请输入..." }
    mode = "default"
    html = ""
    logData: any = []
    activeTab = "basic"
    showPolicyCompare = false
    policyInfo: any = {}
    historyData: any = []
    policy_id: number = null
    history_context = ""
    platform_id = config.api.PID
    preview_context = ""
    preview_his_context = ""

    setDeployTime = false
    deployForm: any = {
        id: undefined,
        deploy_time: undefined
    }
    timeRange: any = null
    get columns() {
        return getHistoryColumns(this)
    }
    get statusStr() {
        const { status } = this.policyInfo
        return this.PolicyStatusMap[status] || ""
    }

    get currentUid() {
        return this.currentUser.uid
    }

    async created() {
        this.policy_id = Number(this.$route.query.id)
        await this.getDetail()
        this.$nextTick(() => {
            this.formatContent()
        })
    }

    @Ref("htmlBody")
    refHtmlBody: HTMLElement

    formatContent() {
        const shadow = this.refHtmlBody.attachShadow({ mode: "open" })
        shadow.innerHTML = this.policyInfo.content
    }

    userInfo(uid: number) {
        return this.allUser[uid] || null
    }
    goBack() {
        this.$router.go(-1)
    }

    changeTab() {
        if (this.activeTab === "log") {
            this.getLogList()
        }
        if (this.activeTab === "history") {
            this.getHistoryList({}, {}, {})
        }
    }

    async download(records: any) {
        const fileData = str2Html(records.content, records.title)
        const docx = await asBlob(fileData)
        saveAs(docx, `${records.title}.docx`)
    }

    async historyPreview(records: any) {
        try {
            this.preview_his_context = records.content || ""
            // 使用 Vue Router 获取完整的 URL
            const routePath = this.$router.resolve({
                path: "/privacyPolicy/preview",
                query: {
                    id: String(this.policy_id),
                    type: "history"
                }
            }).href
            // 在新标签页中打开 URL
            localStorage.setItem("policyHistoryPreviewContent", this.preview_his_context)
            this.previewWindow = window.open(routePath, "_blank")
        } catch (error) {
            this.$message.error(`${error}`)
        }
    }
    toEdit() {
        this.$router.push({
            path: "/policy/edit",
            query: {
                id: String(this.policy_id)
            }
        })
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getHistoryList(_pagination?: any, _filters?: any, _sorter?: any) {
        try {
            // 构建请求参数
            const payload: any = {
                product_id: this.policyInfo.product_id,
                text_type: this.policyInfo.text_type,
                area: this.policyInfo.area
            }

            // 处理时间筛选参数
            if (this.timeRange && this.timeRange.length === 2) {
                const [startDate, endDate] = this.timeRange
                payload.deploy_time_start = startDate
                payload.deploy_time_end = endDate
            }

            const { List } = await policyService.getHistoryVersions(payload)
            this.historyData = List
        } catch (error) {
            this.$message.error(`${error},历史版本获取失败！`)
        }
    }

    handleTimeRangeChange(dates: any) {
        this.timeRange = dates
    }

    searchHistory() {
        this.getHistoryList({}, {}, {})
    }

    resetTimeRange() {
        this.timeRange = null
        this.getHistoryList({}, {}, {})
    }
    previewWindow: Window | null = null
    async toPreview() {
        try {
            const res = await policyService.privacyPolicyPreview({
                id: this.policy_id
            })
            this.preview_context = res || ""
            // 使用 Vue Router 获取完整的 URL
            const routePath = this.$router.resolve({
                path: "/privacyPolicy/preview",
                query: {
                    id: String(this.policy_id),
                    type: "current"
                }
            }).href
            // 在新标签页中打开 URL
            localStorage.setItem("policyPreviewContent", this.preview_context)
            this.previewWindow = window.open(routePath, "_blank")
        } catch (error) {
            this.$message.error(`${error}`)
        }
    }
    onDeploy() {
        // auto_deploy 1 自动部署 2非自动部署 0不能部署
        const { auto_deploy, id } = this.policyInfo
        this.deployForm.id = id
        if (auto_deploy === 1) {
            this.deployForm.deploy_time = undefined
            this.deployPolicy()
        } else if (auto_deploy === 2) {
            this.setDeployTime = true
        } else {
            this.$info({
                title: "提示",
                content:
                    "当前隐私政策不满足部署条件，请联系管理员创建“产品与隐私政策相关对照”后再进行部署上线。"
            })
        }
    }

    handleOk(time: number) {
        this.deployForm.deploy_time = time
        this.deployPolicy()
    }

    async deployPolicy() {
        try {
            const { deploy_time } = this.deployForm
            await policyService.deployPolicy({
                ...this.deployForm
            })
            this.getDetail()
            this.$message.success(
                `部署成功！${
                    deploy_time ? "当前隐私政策不是自动部署，还需自行更新隐私政策链接内容！" : ""
                }`
            )
            this.setDeployTime = false
        } catch (error) {
            this.$message.error(`${error}`)
        }
    }

    async getLogList() {
        try {
            const { current, pageSize } = this.pagination
            const payload = {
                offset: pageSize * (current - 1),
                limit: pageSize,
                id: this.policy_id
            }
            const res: any = await policyService.getOperateRecord(payload)
            const { total = 0, list = [] } = res || {}
            this.pagination.total = total || 0
            this.logData = list || []
        } catch (error) {
            this.$message.error(`${error},操作记录获取失败！`)
        }
    }

    async getDetail() {
        try {
            this.loading = true
            const res = await policyService.getPolicyInfo({
                id: this.policy_id
            })
            this.policyInfo = res || {}
        } catch (error) {
            this.$message.error(`${error}`)
        } finally {
            this.loading = false
        }
    }
    async compare() {
        if (!this.showPolicyCompare) {
            try {
                const res = await policyService.getPreviousPolicy({
                    id: this.policy_id
                })
                this.history_context = res || ""
                if (!this.history_context) {
                    this.$message.warn("无历史版本记录")
                } else {
                    this.showPolicyCompare = !this.showPolicyCompare
                }
            } catch (error) {
                this.$message.error(`${error}`)
            }
        } else {
            this.showPolicyCompare = !this.showPolicyCompare
        }
    }
}
